import { render, staticRenderFns } from "./BluePrintAdd.vue?vue&type=template&id=12289a6f&"
import script from "./BluePrintAdd.vue?vue&type=script&lang=js&"
export * from "./BluePrintAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports